import script from "./PauseResumedModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PauseResumedModal.vue?vue&type=script&setup=true&lang=ts"

import "./PauseResumedModal.vue?vue&type=style&index=0&id=2acc40f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2acc40f0"]])

export default __exports__